<template>
	<teleport to=".popup-area">
		<template v-if="popupActive">
			<div
				class="popup-layout"
				:class="isHidden"
			></div>
			<div
				:class="[isHidden, isFullWidth]"
				class="popup-wrapper"
				v-bind="$attrs"
				@touchmove="preventReloading"
			>
				<slot></slot>
			</div>
		</template>
	</teleport>
</template>

<script>
import { computed } from "vue";
export default {
	inheritAttrs: false,
	props: {
		popupActive: {
			type: Boolean,
			default: false
		},
		fullWidth: {
			type: Boolean,
			default: false
		},
		hidden: {
			type: Boolean,
			default: false
		}
	},
	emits: ['update:modelValue', 'popupClose'],
	setup(props, { emit }){
		
		// const popupActive = computed(() => props.modelValue);
		const isFullWidth = computed(() => props.fullWidth ? "width--full" : "");
		const isHidden = computed(() => props.hidden ? "hidden" : "");
/*		function popupClose(){
			emit("update:modelValue", false);
			emit("popupClose");
		}*/
		function preventReloading(event){
			// event.preventDefault();
		}
		
		return { isFullWidth, isHidden, preventReloading }
	}
}
</script>

<style lang="scss">
@use "@/scss/ui/popup/popup-variables" as *;
@use "@/scss/ui/popup/popup-layout";
@use "@/scss/ui/popup/popup-wrapper";
@use "@/scss/ui/popup/popup-header";
@use "@/scss/ui/popup/popup-sidebar";
@use "@/scss/ui/popup/popup-link";
@use "@/scss/ui/popup/popup";
@use "@/scss/ui/popup/popup-headline";
@use "@/scss/ui/popup/popup-description";
@use "@/scss/ui/popup/popup-label";
@use "@/scss/ui/popup/popup-alert";
@use "@/scss/ui/popup/confirm";
@use "@/scss/ui/scrollbar/scrollbar";

@use "@/scss/sections/editor/elements/field/field-variables" as *;
@use "@/scss/sections/editor/elements/field/field-label";
@use "@/scss/sections/editor/elements/field/field-description";
@use "@/scss/sections/editor/elements/section/section-row";
@use "@/scss/sections/editor/elements/section/row-item";
@use "@/scss/mods/margin";
</style>
